/* eslint-disable import/prefer-default-export */
import { getApiCall } from '../utils/Api';

export const submitOdisImage = async (id) => {
  await getApiCall(`/odis/${id}/approve`);
};
